import type { useHuddleDictation } from './useHuddleDictation';

type Dictation = ReturnType<typeof useHuddleDictation>;

export function HuddleSpeakButton({
  dictation,
  label,
  disabled,
}: {
  dictation: Dictation;
  label: string;
  disabled?: boolean;
}) {
  if (!dictation.supported) return null;
  return (
    <button
      type="button"
      className="huddle-speak"
      aria-label={label}
      aria-pressed={dictation.listening}
      disabled={disabled || dictation.voiceCapturing}
      onMouseDown={(event) => event.preventDefault()}
      onClick={dictation.toggle}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <rect x="9" y="2" width="6" height="12" rx="3" />
        <path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3M8 22h8" />
      </svg>
      {dictation.listening ? <span className="huddle-speak-dot" aria-hidden="true" /> : null}
      {dictation.listening ? 'Listening… tap to stop' : 'Speak'}
    </button>
  );
}

export function HuddleSpeakFeedback({ dictation }: { dictation: Dictation }) {
  return (
    <>
      {dictation.interim ? (
        <div className="huddle-dictation-preview">{dictation.interim}</div>
      ) : null}
      {dictation.blocked ? (
        <p className="huddle-mic-error" role="status">
          Mic blocked. Allow the microphone for this site, or use the keyboard mic.
        </p>
      ) : null}
    </>
  );
}
